export const productShortName = 'Telecommunications & Fiber Optic Networks — Professional Edition';
export const productBrand = 'Telecommunications & Fiber Optic Networks';
export const productEdition = 'Professional Edition';
export const productLabel = 'Telecommunications & Fiber Optic Networks · Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/7ft6UK1jTsPqFbAJTdH112/MOCKUP_FIBER.png';
export const productImageAlt =
  'Telecommunications & Fiber Optic Networks Professional Edition: six volumes covering fiber optics and OTDR, structured cabling, FTTH and PON, microwave links, towers and cell sites, and operations and maintenance, plus five bonus resources';

export const checkoutUrl = 'https://telecom-fiber-optic-networks.impultienda.ar/checkout';

export const price = '$27';
export const priceBefore = '$80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '$14';
export const bonusTotalValue = '$70';

export const closingLines = [
  'No more confusion about how light travels through fiber and where the loss goes',
  'No more uncertainty reading OTDR traces and loss budgets',
  'No more gaps in understanding FTTH, PON, radio links and cell sites',
  'No more improvising installation, inspection and maintenance procedures',
  'No more facing fiber cuts and network alarms without a clear method',
];
